import React from 'react'
import axios from 'axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import DBConn from '~/Classes/siteVars.js'
import queryString from 'query-string';
import { connect } from 'react-redux';
import LandingPageTemplate from '../../login/template'

@connect((store) => {
    return { siteMaster: store.siteMaster }
})

export default class AppConnect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appData: {},
            appid: 0,
            code: "",
            appLoaded: false,
            redirect: ""
        }

        this.loadApp = this.loadApp.bind(this);
        this.login = this.login.bind(this);
        this.register = this.register.bind(this);
    }

    componentDidMount() {

        const query = queryString.parse(location.search);
        var appid = query.appid;
        var code = query.code;
        if (this.props.match && this.props.match.params && this.props.match.params.appId) appid = this.props.match.params.appId;


        var authorise = false
        if (appid && appid.indexOf('_') > -1) {
            var split = appid.split('_')
            appid = split[0]
            authorise = !!split[1]
        }
        // hubspot hack
        if (appid == 55) appid = 46

        var redirect = ''
        if (code) {
            redirect = "/cp/company/integrations/oAuth/response/" + appid + "?code=" + code;
        }
        this.setState({ appid: appid, code, redirect, authorise }, this.loadApp)
    }

    loadApp() {
        var baseUrl = DBConn.getConnString()
        axios.get(baseUrl + '/api/oauth/app/' + this.state.appid).then(_res => {
            var redirect = this.state.redirect
            var app = _res.data.Application
            var theURI
            if (!redirect && app.oAuthAuthoriseUri) {
                theURI = app.oAuthAuthoriseUri;
                theURI = theURI.replace(/\[OAUTHCLIENTID\]/g, app.oAuthAppId);
                // theURI = theURI.replace(/\[RANDNO\]/g, this.props.user.token);
                var redirectURI = window.location.origin;
                if (redirectURI === 'https://app.transpond.io') {
                    redirectURI = 'https://web.mpzmail.com'
                } else if (redirectURI === 'http://localhost:8082') {
                    redirectURI = 'http://localhost:8082'
                }
                var toReplaceWith = redirectURI + "/cp/company/integrations/oAuth/response/" + app.id
                if (app.options && app.options.backendAuth) {
                    let domain = this.props.siteMaster.trackingDomain
                    if (domain === 'api.transpond.io') {
                        domain = 'api.mpzmail.com'
                        toReplaceWith = 'https://' + domain + '/api/oauth/app/' + app.id + '/oauth'
                    } else if (domain === 'localhost:8082') {
                        domain = 'localhost:8082'
                        toReplaceWith = 'http://' + domain + '/api/oauth/app/' + app.id + '/oauth'
                    }
                }
                theURI = theURI.replace(/\[OAUTHREDIRECTURL\]/g, toReplaceWith);
                // redirect = encodeURIComponent(theURI)
                redirect = '/appconnect?appid=' + app.id + '_1'
            }
            if (this.state.authorise && theURI) {
                window.open(theURI, '_self');
            } else {
                this.setState({ appData: _res.data.Application, appLoaded: true, redirect })
            }
        }).catch(err => {
            this.setState({})
        })

    }

    login() {
        window.open('/?redirect=' + this.state.redirect, "_self")
    }

    register() {
        window.open('/register?redirect=' + this.state.redirect, "_self")
    }

    render() {
        if (!this.state.appLoaded) return <div></div>

        var ourSiteLogo = "http://cdn1.ourmailsender.com/siteContent/transpondLogos/logomark_dark.png";
        if (this.props.siteMaster.siteId != 1) ourSiteLogo = this.props.siteMaster.siteLogo;
        if (this.props.siteMaster.siteId == "4") ourSiteLogo = "http://cdn1.ourmailsender.com/siteContent/appLogos/myGoldMail.jpg";

        var ourAppDescription = this.state.appData.appDescription;
        if (ourAppDescription) ourAppDescription = ourAppDescription.replace(/transpond/gi, this.props.siteMaster.siteName)

        return (
            <LandingPageTemplate
                paperClasses="landing-appconnect"
                top={<TopIcon app={this.state.appData} site={this.props.siteMaster} />}
                header={"Connect " + (this.state.appData.friendlyName || this.state.appData.appName) + " to " + this.props.siteMaster.siteName}
                subheader={this.state.appData.appDescription}
                paperFooter={<div className="row">
                    <div className="col-xs-4" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        <Feature name="Campaign Tracking" />
                        <Feature name="AI Content Assistant" />
                    </div>
                    <div className="col-xs-4" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        <Feature name="Signup Forms" />
                        <Feature name="Advanced Analytics" />
                    </div>
                    <div className="col-xs-4" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        <Feature name="Friendly Support" />
                        <Feature name="Social Campaigns" />
                    </div>
                </div>
                }
            >
                <Paper>
                    <div className="quickFlex" style={{ flexDirection: 'column', alignItems: "center", justifyContent: "center" }}>
                        <div
                            className="mar-b16"
                            style={{ fontWeight: 600, fontSize: 16, lineHeight: '20px' }}
                        >Do you have an existing {this.props.siteMaster.siteName} account?</div>
                        <div className="quickFlex" style={{ gap: 12 }}>
                            <Button to={"/?redirect=" + this.state.redirect} className="button-primary" iconRight={<Icons icon="arrowRight" />}>Yes, Login</Button>
                            <Button to={"/register?redirect=" + this.state.redirect}>No, Create a new {this.props.siteMaster.siteName} account</Button>
                        </div>
                    </div>

                </Paper>
            </LandingPageTemplate>
        )

        return <div className="container-fluid">
            <Row className="height-100-vh center-xs middle-xs">
                <Column xs={12} style={{ width: "100%", maxWidth: "600px" }}>
                    <Paper>


                        <h4 className="mar-b25">Connect <span className="text-heavy text-primary">{this.props.siteMaster.siteName}</span>  to <span className="text-heavy text-primary">{this.state.appData.friendlyName || this.state.appData.appName}</span></h4>


                        <div className="quickFlex mar-b25">
                            <div style={{ flex: 1 }}>
                                <img src={ourSiteLogo} style={{ width: "50px" }} />
                            </div>
                            <div>
                                <Icons icon="switch" color="grey" style={{ width: 30, height: 30 }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <img src={this.state.appData.appLogoUri} className="rounded" style={{ width: "50px" }} />
                            </div>
                        </div>


                        <div className="mar-b25">{ourAppDescription}</div>

                        <h4 className="mar-b25">Do you already have a {this.props.siteMaster.siteName} account?</h4>

                        <div className="quickFlex center-xs mar-b25">
                            <Button className="button-primary mar-r10" text="Yes, Login" onClick={this.login} />
                            <span>or <a onClick={this.register}> Create a new account</a></span>
                        </div>

                        <hr className="hide-xs" />

                        <Row style={{ textAlign: "left" }} className="hide-xs">
                            <Column xs={12} sm={6} md={4} className="quickFlex mar-b25" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" />
                                <span>Unlimited Contacts</span>
                            </Column>
                            <Column xs={12} sm={6} md={4} className="quickFlex mar-b25" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" /><span>No Setup Fee</span>
                            </Column>

                            <Column xs={12} sm={6} md={4} className="quickFlex mar-b25" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" /> <span>Friendly Support</span>
                            </Column>

                            <Column xs={12} sm={6} md={4} className="quickFlex" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" /><span>Email Templates</span>
                            </Column>
                            <Column xs={12} sm={6} md={4} className="quickFlex" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" /> <span>Campaign Tracking</span>
                            </Column>
                            <Column xs={12} sm={6} md={4} className="quickFlex" style={{ alignItems: "flex-start" }}>
                                <Icons icon="tick" className="mar-r5" /> <span>Automation</span>
                            </Column>

                        </Row>

                    </Paper>
                </Column>
            </Row>
        </div >
    }

};

function TopIcon({ app, site }) {
    if (site.siteId !== 1) {
        return <div className="landing-appconnect__app-icons__app quickFlex" style={{ justifyContent: "center", alignItems: "center", marginBottom: 16 }}>
            <img src={app.appLogoUri} />
        </div>
    }
    return (
        <div className="landing-appconnect__app-icons">
            <div className="landing-appconnect__app-icons__app">
                <img src={app.appLogoUri} />
            </div>
            <div className="landing-appconnect__app-icons__site">
                <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="10.44" y="-0.372119" width="52" height="52" rx="17" transform="rotate(12 10.44 -0.372119)" fill="black" />
                    <rect x="10.44" y="-0.372119" width="52" height="52" rx="17" transform="rotate(12 10.44 -0.372119)" stroke="white" strokeWidth="4" />
                    <g clipPath="url(#clip0_2526_39739)">
                        <path d="M29.6183 18.7841L25.3257 20.172L21.9834 17.1613L26.2613 15.7703L29.6183 18.7841Z" fill="white" />
                        <path d="M32.9768 21.7982L28.6842 23.1861L25.3271 20.1723L29.6198 18.7844L32.9768 21.7982Z" fill="white" />
                        <path d="M36.3322 24.8119L32.0396 26.1997L28.6826 23.1859L32.9752 21.7981L36.3322 24.8119Z" fill="white" />
                        <path d="M39.6897 27.8256L35.3971 29.2134L32.04 26.1996L36.3327 24.8118L39.6897 27.8256Z" fill="white" />
                        <path d="M43.0324 30.8362L38.7544 32.2271L35.3974 29.2133L39.69 27.8254L43.0324 30.8362Z" fill="white" />
                        <path d="M34.4616 33.6152L33.526 38.0169L29.2333 39.4047L30.1689 35.0031L34.4616 33.6152Z" fill="white" />
                        <path d="M43.0328 30.8362L42.0972 35.2379L37.8193 36.6289L38.7549 32.2272L43.0328 30.8362Z" fill="white" />
                        <path d="M25.8776 36.3911L24.942 40.7928L20.6493 42.1806L21.5849 37.779L25.8776 36.3911Z" fill="white" />
                        <path d="M27.7472 27.5876L23.4546 28.9755L20.1123 25.9648L24.3902 24.5738L27.7472 27.5876Z" fill="white" />
                        <path d="M31.1057 30.6015L26.8131 31.9893L23.456 28.9755L27.7487 27.5877L31.1057 30.6015Z" fill="white" />
                        <path d="M34.4611 33.6151L30.1685 35.003L26.8115 31.9892L31.1041 30.6013L34.4611 33.6151Z" fill="white" />
                        <path d="M26.2613 15.7703L25.3257 20.172L21.0478 21.5629L21.9834 17.1613L26.2613 15.7703Z" fill="white" />
                        <path d="M24.3902 24.5738L23.4546 28.9755L19.1767 30.3664L20.1123 25.9648L24.3902 24.5738Z" fill="white" />
                        <path d="M25.8761 36.3908L21.5835 37.7787L18.2412 34.768L22.5191 33.377L25.8761 36.3908Z" fill="white" />
                        <path d="M22.5191 33.377L21.5835 37.7787L17.3056 39.1696L18.2412 34.768L22.5191 33.377Z" fill="white" />
                        <path d="M29.6183 18.7841L25.3257 20.172L21.9834 17.1613L26.2613 15.7703L29.6183 18.7841Z" fill="white" />
                        <path d="M32.9768 21.7982L28.6842 23.1861L25.3271 20.1723L29.6198 18.7844L32.9768 21.7982Z" fill="white" />
                        <path d="M36.3322 24.8119L32.0396 26.1997L28.6826 23.1859L32.9752 21.7981L36.3322 24.8119Z" fill="white" />
                        <path d="M39.6897 27.8256L35.3971 29.2134L32.04 26.1996L36.3327 24.8118L39.6897 27.8256Z" fill="white" />
                        <path d="M43.0324 30.8362L38.7544 32.2271L35.3974 29.2133L39.69 27.8254L43.0324 30.8362Z" fill="white" />
                        <path d="M34.4616 33.6152L33.526 38.0169L29.2333 39.4047L30.1689 35.0031L34.4616 33.6152Z" fill="white" />
                        <path d="M43.0328 30.8362L42.0972 35.2379L37.8193 36.6289L38.7549 32.2272L43.0328 30.8362Z" fill="white" />
                        <path d="M25.8776 36.3911L24.942 40.7928L20.6493 42.1806L21.5849 37.779L25.8776 36.3911Z" fill="white" />
                        <path d="M27.7472 27.5876L23.4546 28.9755L20.1123 25.9648L24.3902 24.5738L27.7472 27.5876Z" fill="white" />
                        <path d="M31.1057 30.6015L26.8131 31.9893L23.456 28.9755L27.7487 27.5877L31.1057 30.6015Z" fill="white" />
                        <path d="M34.4611 33.6151L30.1685 35.003L26.8115 31.9892L31.1041 30.6013L34.4611 33.6151Z" fill="white" />
                        <path d="M26.2613 15.7703L25.3257 20.172L21.0478 21.5629L21.9834 17.1613L26.2613 15.7703Z" fill="white" />
                        <path d="M24.3902 24.5738L23.4546 28.9755L19.1767 30.3664L20.1123 25.9648L24.3902 24.5738Z" fill="white" />
                        <path d="M25.8761 36.3908L21.5835 37.7787L18.2412 34.768L22.5191 33.377L25.8761 36.3908Z" fill="white" />
                        <path d="M22.5191 33.377L21.5835 37.7787L17.3056 39.1696L18.2412 34.768L22.5191 33.377Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2526_39739">
                            <rect width="27" height="27" fill="white" transform="translate(20.8008 14.6096) rotate(12)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
    )
}

function Feature({ name }) {
    return (
        <div className="quickFlex" style={{ alignItems: "center" }}>
            <div style={{ height: 16, width: 16, backgroundColor: "var(--indigo-700)", borderRadius: '50%', display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Icons icon="tick" color="white" style={{ alignItems: 'center', height: 16, width: 16 }} />
            </div>
            <div style={{
                marginLeft: 6, fontWeight: 400, fontSize: 14, lineHeight: '22px', letterSpacing: '-0.13px', color: 'var(--neutral-800)'
            }}>{name}</div>
        </div>

    )
}